import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNumber } from 'lodash-es';

export function createCNPValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = Number(control.value);
    if (!isNumber(value) || value?.toString().length !== 13) {
      return { cnpValid: false };
    }
    const digits = value.toString().split('').map(Number);
    const constantDigits = '279146358279'.split('').map(Number);
    const controlDigit = digits[digits.length - 1];
    let sum = 0;
    for (let i = 0; i < digits.length - 1; i++) {
      sum += digits[i] * constantDigits[i];
    }
    const hash = sum % 11 < 10 ? sum % 11 : 1;

    return controlDigit === hash ? null : { cnpValid: false };
  };
}
